// extracted by mini-css-extract-plugin
module.exports = {"body":"styles__body___3G231","icon":"styles__icon___HuTHh"};